import dayjs from "dayjs";

const getSortedData = (data, sortCriteria) => {
  let filteredCourses = data;

  for (const { key, order, dataKeys } of sortCriteria) {
    const isAscending = order === "asc";

    // Access the nested array within filteredCourses using the provided dataKeys
    const coursesArray = dataKeys
      ? dataKeys.reduce(
          (current, dataKey) => current?.[dataKey] || null,
          filteredCourses
        )
      : filteredCourses;
    if (!Array.isArray(coursesArray)) return []; // If coursesArray isn't an array, return an empty array

    // Filter out null and undefined course objects
    filteredCourses = coursesArray.filter(
      (course) => course !== null && course !== undefined
    );

    if (filteredCourses.length === 0) return []; // If no valid courses remain, return an empty array

    // Determine the type of the first course's specified key value to ensure consistency
    const firstCourseValue = filteredCourses[0][key];
    const isFirstValueDayjs = dayjs.isDayjs(firstCourseValue);
    const firstValueType = isFirstValueDayjs
      ? "dayjs"
      : typeof firstCourseValue;

    // Verify all courses have the same type for the specified key
    if (
      !filteredCourses.every((course) => {
        const courseValue = course[key];
        const courseValueType = dayjs.isDayjs(courseValue)
          ? "dayjs"
          : typeof courseValue;
        return courseValueType === firstValueType;
      })
    ) {
      return [];
    }

    // Sort the courses based on the specified key and order
    filteredCourses = filteredCourses.sort((a, b) => {
      const valA = a[key];
      const valB = b[key];

      // If values are Day.js instances, sort by date
      if (dayjs.isDayjs(valA) && dayjs.isDayjs(valB)) {
        return isAscending
          ? valA.valueOf() - valB.valueOf()
          : valB.valueOf() - valA.valueOf();
      }
      // If values are strings, use localeCompare for alphabetical order
      if (typeof valA === "string" && typeof valB === "string") {
        return isAscending
          ? valA.localeCompare(valB)
          : valB.localeCompare(valA);
      }
      // If values are numbers, sort numerically
      if (typeof valA === "number" && typeof valB === "number") {
        return isAscending ? valA - valB : valB - valA;
      }
      return 0; // If types aren't comparable, maintain original order
    });
  }

  return filteredCourses; // Return the final sorted array
};

export default getSortedData;
